import { render, staticRenderFns } from "./SubtitleCollapsibleWithAdd.vue?vue&type=template&id=27ed0da3"
import script from "./SubtitleCollapsibleWithAdd.vue?vue&type=script&lang=ts"
export * from "./SubtitleCollapsibleWithAdd.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports